import { render, staticRenderFns } from "./MapCaixa.vue?vue&type=template&id=814d82f8&scoped=true&"
import script from "./MapCaixa.vue?vue&type=script&lang=js&"
export * from "./MapCaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814d82f8",
  null
  
)

export default component.exports